import { getCookie, hasWindow } from "@litres/utils";
import { v4 as uuidv4 } from "uuid";
import type {
  IEvent,
  IEventData,
  ITrackerConfig,
  ITrackerRequestData,
} from "./TrackerManager.types";

export const getTrackerEvent = <T extends object>(
  event: IEventData<T>
): IEvent => {
  return {
    eventUUID: uuidv4(),
    eventTime: `${Date.now()}`,
    retryCounter: 0,
    eventType: event.eventType,
    params: {
      ...event.params,
      ...getEventRefUrl<T>(event.params),
    },
  };
};

const getEventRefUrl = <T extends object>(
  params: T
): { ref_url?: string | unknown } => {
  if (hasWindow && (window.customReferrer || document.referrer)) {
    return { ref_url: window.customReferrer || document.referrer };
  } else if ("ref_url" in params) {
    return { ref_url: params.ref_url };
  }
  return {};
};

const getHostRegion = () => {
  if (!hasWindow) {
    return;
  }
  const currentHost =
    new URLSearchParams(window.location.search).get("clientHost") ||
    window.location.host;

  switch (currentHost) {
    case "www.litres.ru":
      return "ru";
    case "litres.uz":
      return "uz";
    case "litres.az":
      return "az";
    case "litres.de":
      return "de";
    case "litres-tr.com":
      return "tr";
    case "litres.com":
      return "com";
    case "litres.ee":
      return "ee";
    case "litres.es":
      return "es";
    case "litres.pl":
      return "pl";
    case "litres.ua":
      return "ua";
    default:
      return undefined;
  }
};

/**
 * Составляет полный объект данных о событии из специфичных данных о нём и данных из конфигурации трекера.
 */
export const prepareFullEventDataForSending = (
  specialDataOfEvent: IEvent,
  config: ITrackerConfig
): ITrackerRequestData => {
  const {
    userID,
    isAutoreg,
    host,
    subscriptionUserStatus,
    deviceModel,
    abVariants,
    registrationDate,
    varioqubAbVariants,
    varioqubUserId,
  } = config;

  return {
    ab_variants: abVariants,
    device_model: deviceModel,
    event_date: specialDataOfEvent.eventTime,
    event_id: specialDataOfEvent.eventUUID,
    event_parameters: specialDataOfEvent.params,
    event_type: specialDataOfEvent.eventType,
    registration_date: registrationDate,
    host,
    host_region: getHostRegion(),
    sid: getCookie("SID") || "",
    subscription_user_status: subscriptionUserStatus,
    user_id: userID,
    is_autoreg: isAutoreg,
    varioqube_uid: varioqubUserId,
    varioqube_ab_variants: varioqubAbVariants,
    yametrika_id: getCookie("_ym_uid"),
  };
};
